import { render } from "./DeleteUserModal.vue?vue&type=template&id=6faab351&scoped=true&ts=true"
import script from "./DeleteUserModal.vue?vue&type=script&lang=ts"
export * from "./DeleteUserModal.vue?vue&type=script&lang=ts"

import "./DeleteUserModal.vue?vue&type=style&index=0&id=6faab351&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faab351"]])

export default __exports__